import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import PatOcorrencias from "./PatOcorrencias";

const PatExistenteDetalhes = ({ row }) => {
  const dados = row.data;

  return (
    <div style={{ width: "100%" }}>
      <Row style={{ margin: 20, textAlign: "left" }}>
        <Col sm="3">
          <strong>Data da decisão: </strong>
          <br />
          <span>{dados.tmJulgamento}</span>
        </Col>
        <Col sm="5">
          <strong>Responsável pela Decisão: </strong>
          <br />
          <span>{dados.txResponsavel}</span>
        </Col>
      </Row>
      <Row style={{ margin: 20, textAlign: "left" }}>
        <Col sm="3">
          <strong>Data da Baixa: </strong>
          <br />
          <span>{dados.tmBaixa}</span>
        </Col>
        <Col sm="3">
          <strong>Motivo da Baixa: </strong>
          <br />
          <span>{dados.motivoBaixa}</span>
        </Col>
      </Row>
      <Row style={{ margin: 20, textAlign: "left" }}>
        <Col sm="11">
          <strong>Ocorrências: </strong>
          <br />
          <div className="card-header pt-3 pb-0 flex-row w-100">
            <Form.Group as={Row} className="d-flex flex-row">
              <Col sm="11" style={{ marginBottom: 15 }} className="form-inline justify-content-end">
                <PatOcorrencias dadosPat={dados} />
              </Col>
            </Form.Group>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default PatExistenteDetalhes;
